import { DatePipe } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { ActivityStoreFacade } from '../../../common/facade/ActivityStoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { CatalogDetInfo } from '../../../common/model/dictionary/CatalogDetInfo';
import { StoreReportDto } from '../../../common/model/dto/StoreReportDto';
import { Organization } from '../../../common/model/Organization';
import { ExcelUtility } from '../../../common/util/ExcelUtility';

@Component({
  selector: 'app-store-report',
  templateUrl: './store-report.component.html',
  styleUrls: ['./store-report.component.css'],
})
export class StoreReportComponent implements OnInit {
  public res = res;
  titleStoresReport = res.StoresReport;
  lblDownload = res.Download;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  lblSearch = res.Search;
  lblStore = res.Store;
  lblCumulativeTotal = res.CumulativeTotal;
  lblOpeningChecklist = res.StoreOpeningChecklist;
  lblClosingChecklist = res.StoreClosingChecklist;
  lblLevelChange = res.ChangeMarketingCampaign;
  lblReception = res.Reception;
  lblMerchandiseEntry = res.MerchandiseEntry;
  lblCorrectiveActions = res.CorrectiveActions;
  public catDetMerchandiseEntry = CatalogDetInfo.catDetToUseShipmentEntry;
  public catDetReception = CatalogDetInfo.catDetToUseShipmentReception;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: '',
  };

  loading = false;
  messageLoader = '';
  message = '';
  public backToVisible = false;
  public lstStoreReport: StoreReportDto[] = [];
  public storeReport: StoreReportDto;
  private _filteredData = [];
  public txtSearch = '';
  public txtMinDate = new Date(
    this.getNowUTC().getFullYear() - 1,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds()
  );
  public txtMaxDate = this.getNowUTC();
  public txtStartDate = new Date();
  public txtEndDate = new Date();

  // alert
  alerts: any[] = [];

  public TenantId = 0;
  organizationId: string;

  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  public organizationSelected: any[] = [];
  strOrganizationSelected: string;
  botonEnable: boolean;

  constructor(
    @Inject(SESSION_STORAGE) private storage: WebStorageService,
    private _facade: ActivityStoreFacade,
    private _router: Router,
    private _route: ActivatedRoute,
    private _excel: ExcelUtility,
    public strings: Strings,
    private localeService: BsLocaleService
  ) {
    this.storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.messageLoader = 'Cargando';
    this.messagesTable.emptyMessage = this.strings.GetText(
      res.ThereIsNoInformation
    );
    this.messagesTable.totalMessage = 'Total';

    this.TenantId = this.strings.getTenant();
    this.localeService.use(this.strings.getLanguage());

    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.lstOrganization = this.availableOrganizations.filter(
      (Orga) => Orga.tenantId == this.TenantId
    );
    this._route.queryParams.subscribe((params) => {
      if (params['orgId'] !== undefined) {
        this.organizationId = params['orgId'];
        this.strOrganizationSelected = this.organizationId;
        this.organizationSelected = this.lstOrganization.filter((org) =>
          this.organizationId.includes(org.organizationId)
        );
        this.selectedOrganizations = this.lstOrganization;
        this.botonEnable = true;
      }

      if (
        params['startDate'] !== undefined &&
        params['endDate'] !== undefined
      ) {
        this.txtStartDate = new Date(params['startDate']);
        this.txtEndDate = new Date(params['endDate']);
        this.getReportBy();
      }
    });
  }

  onChangeStartDate(value) {
    value = this.subtractTimeFromDate(value, 6);
    this.txtStartDate = value;

    if (this.txtStartDate > this.txtEndDate) {
      this.addAlert(
        '<strong>!Error¡</strong> ' +
        this.strings.GetText(res.AlertTheStartDateCannotBeHigher),
        'danger'
      );
    }
  }

  onChangeEndDate(value) {
    value = this.subtractTimeFromDate(value, 6);
    this.txtEndDate = value;
  }

  // añadir alert
  addAlert(message: String, type: String): void {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message,
    });
  }
  /**
   * Método para cerarr las notificaciones.
   * @param dismissedAlert
   */
  // cerrar alert
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    this.txtSearch = event.target.value.toLowerCase();
    // get the amount of columns in the table
    this.filterData(this.txtSearch);
  }

  /**
   * Método para descargar el reporte de las tiendas
   */
  downloadLayout() {
    if (this.lstStoreReport.length > 0) {
      const data: any = [];
      this.lstStoreReport.forEach((row) => {
        const info = {
          [this.strings.GetText(res.Store)]: row.storeCode,
          [this.strings.GetText(res.StoreName)]: row.storeName,
          [this.strings.GetText(res.CumulativeTotal)]:
            row.activitiesTotalPercent,
          [this.strings.GetText(res.StoreOpeningChecklist)]:
            row.aperturaTotalPercent,
          [this.strings.GetText(res.StoreClosingChecklist)]:
            row.cierreTotalPercent,
          [this.strings.GetText(res.ChangeMarketingCampaign)]:
            row.changeLevelTotalPercent,
          [this.strings.GetText(res.Reception)]: row.receptionTotalPercent,
          [this.strings.GetText(res.MerchandiseEntry)]:
            row.merchandiseEntryTotalPercent,
          [this.strings.GetText(res.SupervisorChecklist)]: '',
          [this.strings.GetText(res.VIMChecklist)]: '',
          [this.strings.GetText(res.CorrectiveActions)]:
            row.activStoreInstActTotalPercent,
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertNoInfoToDownload), 'danger');
    }
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  }

  onViewDetail(storeid: number, taskTypeId: number) {
    const item = this.lstStoreReport.find((x) => x.storeId === storeid);

    if (taskTypeId != CatalogDetInfo.CatDetActionCorrective) {
      this._router
        .navigate([
          '/store-report-detail/',
          item.storeId,
          taskTypeId,
          this.txtStartDate.toDateString(),
          this.txtEndDate.toDateString(),
          this.strOrganizationSelected,
        ])
        .then((e) => {
          if (e) {
            console.log('Navigation is successful!');
          } else {
            console.log('Navigation has failed!');
          }
        });
    } else {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          pSt: item.storeId,
          pType: -1,
          pStart: this.txtStartDate.toDateString(),
          pEnd: this.txtEndDate.toDateString(),
          path: 'StoreReport',
          orgId: this.strOrganizationSelected,
        },
      };
      this._router.navigate(['/actions-detail'], navigationExtras).then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
    }
  }

  private filterData(val) {
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.lstStoreReport = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (
          item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)
        ) {
          return true;
        }
      }
    });
  }

  getReportBy() {
    this.loading = true;
    if (this.txtStartDate > this.txtEndDate) {
      this.addAlert(
        '<strong>' +
        this.strings.GetText(res.AlertTheStartDateCannotBeHigher) +
        '</strong>',
        'danger'
      );
      this.loading = false;
    } else {
      this._facade
        .GetStoresReport(this.txtStartDate, this.txtEndDate)
        .subscribe(
          (result) => {
            if (result.completed) {
              this.lstStoreReport = result.data.filter((org) =>
                this.strOrganizationSelected.includes(org.organizationId)
              );
              this._filteredData = this.lstStoreReport;
            } else {
              this.addAlert(
                '<strong>' + result.message + '</strong>',
                'danger'
              );
            }
            this.loading = false;
          },
          (error) => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
          }
        );
    }
  }

  onChangeOrganization(selectedOrganizations: any[]) {
    this.selectedOrganizations = selectedOrganizations;
    this.strOrganizationSelected = this.selectedOrganizations
      .map((e) => e.organizationId)
      .join(',');
    if (selectedOrganizations.length > 0) {
      this.botonEnable = true;
    } else {
      this.botonEnable = false;
      this.lstStoreReport = [];
    }
  }

  search() {
    this.getReportBy();
  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = intHours * 60 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }
}
